// Wildfool: Lazy-load offscreen autoplay videos to protect LCP.
// Strips src from <video autoplay> below the fold; restores via IntersectionObserver.
(function () {
  if (!('IntersectionObserver' in window)) return;
  const init = () => {
    const vids = Array.from(document.querySelectorAll('video[autoplay]'));
    const lazy = vids.filter(v => v.getBoundingClientRect().top > window.innerHeight);
    if (!lazy.length) return;
    lazy.forEach(v => {
      v.preload = 'none';
      v.querySelectorAll('source').forEach(s => {
        if (s.src) { s.dataset.lazySrc = s.src; s.removeAttribute('src'); }
      });
      if (v.src) { v.dataset.lazySrc = v.src; v.removeAttribute('src'); }
    });
    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach(e => {
        if (!e.isIntersecting) return;
        const v = e.target;
        v.querySelectorAll('source[data-lazy-src]').forEach(s => { s.src = s.dataset.lazySrc; });
        if (v.dataset.lazySrc) v.src = v.dataset.lazySrc;
        v.load();
        obs.unobserve(v);
      });
    }, { rootMargin: '300px' });
    lazy.forEach(v => io.observe(v));
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
